import React from 'react';
import ClickHandlerWithLoaderContainer from '../../../../Common/ClickHandlerWithLoader/ClickHandlerWithLoaderContainer';
import SettingsRow from '../../../Common/SettingsRow/SettingsRow';
import { getI18N } from 'qs-services/i18N';

export default ({ onSelected, settingComponentId, classForContainer }) => {
  const { t } = getI18N();

  return (
    <ClickHandlerWithLoaderContainer
      clickProps={{
        clickHandler: onSelected,
        clickParams: settingComponentId
      }}
      type="button"
      classForContainer={classForContainer}
    >
      <SettingsRow
        imageSrc={'https://web.quicksell.co/static/media/ic_plans.png'}
        title={t('plans_and_billing')}
      >
        <span>{t('manage_your_current_plan_and_billing_information')}</span>
      </SettingsRow>
    </ClickHandlerWithLoaderContainer>
  );
};
